import { isEmptyDocument } from '@/lib/editor/editor';

export const richTextFn = ({ propertyValues, scope }) => {
  const value = propertyValues.find((pv) => pv.property.uid === scope.property.uid)?.document;
  if (value === undefined) {
    return false;
  }

  return scope.isEmpty === true && isEmptyDocument(value);
};

export const directRichTextFn = ({ entity, scope }) => {
  const value = entity[scope.directProperty.edgeName];
  if (value === undefined) {
    return false;
  }

  return scope.isEmpty === true && isEmptyDocument(value);
};
